import styled from 'styled-components'
import StyledIcon from '../styled-icon';
import { BodySmall } from '../typography/styled'
import SVG from "react-inlinesvg";
type ActiveProp = {
  active?:boolean,
  disable?:boolean,
  hover?:boolean,
}

export const Container = styled.div<ActiveProp>`
  display: flex;
  box-sizing: border-box;
  position: relative;
  flex-direction: column;
  width: ${({active}) => active ? '70px' : '280px'};
  transition: 0.2s width ease-in-out;
  /* position: absolute; */
  min-height: 100vh;
  height: auto;
  padding: ${({active}) => active ? '0 15px' : '0 20px'};
  z-index: 10;
  background-color: ${({theme}) => theme.palette[100]};

  @media screen and (max-width: 900px) {
    min-height: 100vh;
    height: auto;
    padding: ${({active}) => active ? '0 13px' : '0 20px'};
  }

  @media screen and (max-width: 768px) {
    position: fixed;
    top: 0;
    bottom: auto;
    left: ${({active}) => active ? '-280px' : '0'};
    width: 280px;
    min-height: 0;
    height: 100vh;
    height: 100dvh;
    max-height: 100dvh;
    padding: 0 20px calc(20px + env(safe-area-inset-bottom, 0px));
    scroll-padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    z-index: 1000;
    box-shadow: ${({active}) => active ? 'none' : '2px 0 10px rgba(0, 0, 0, 0.1)'};
    transition: left 0.2s ease-in-out;
  }
`

export const MobileOverlay = styled.div<ActiveProp>`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.45);
    opacity: ${({active}) => active ? '0' : '1'};
    pointer-events: ${({active}) => active ? 'none' : 'auto'};
    transition: opacity 0.2s ease-in-out;
  }
`
export const ArrowCloseImg = styled(SVG)<ActiveProp>`
  transform: ${({active}) => active ? 'scale(-1, 1)' : ''};
  transition: 0.2s transform ease-in-out;
  z-index: 9;
  opacity: ${({hover, disable}) => hover || disable ? '0.7' : ''};
  filter: ${({active, disable}) => active && !disable ? 'brightness(77%)' : ''};
  &:hover {
    cursor: pointer;
    opacity: ${({hover}) => hover ? '' : '0.7'};
  }
  &:active{
    filter: ${({disable}) => !disable ? 'brightness(77%)' : ''};
  }
  & path {
    stroke:${({theme}) => theme.palette[800]};
  }
  max-width:14px;
`
export const LogoImg = styled(SVG)<ActiveProp>`
  /* height: ${({active}) => active ? '26px' :'38px'};
  top: ${({active}) => active ? '27.5px' :'21px'}; */
  left:${({active}) => active ? '20.5px' :'30px'};
  top:29px;
  z-index: 1;
  position: absolute;
  &:hover{
    cursor:pointer;
    opacity: 0.7;
  }
  & path {
    /* fill:${({theme}) => theme.palette[800]}; */
  }

`
export const TitleDivider = styled.h2<ActiveProp>`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  padding:0px;
  margin-top: 30px;
  margin-bottom: 10px;
  margin-left: 0;
  text-align: ${({active}) => active ? 'center' : 'left'};
  color: ${({theme, active}) => active ? theme.palette[700] : theme.palette[600]};
  text-transform: uppercase;
  white-space: nowrap;
`
export const ClientSwitcher = styled.div<ActiveProp>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: ${({active}) => active ? 'center' : 'flex-start'};
  gap: ${({active}) => active ? '0' : '10px'};
  width: 100%;
  margin-bottom: 20px;
  min-height: 56px;
  padding: ${({active}) => active ? '10px 0' : '10px 12px'};
  border-radius: ${({theme}) => theme.radius.search};
  border: ${({theme}) => `1px solid ${theme.neutral[15]}`};
  background-color: ${({theme}) => theme.palette[10]};
  cursor: pointer;
  box-shadow: ${({theme}) => theme.shadows.control};
  transition: 0.15s background-color ease-in-out, 0.15s border-color ease-in-out;
  overflow: hidden;
  &:hover {
    background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.accent[10]};
    border-color: ${({theme}) => theme.isDark ? theme.palette[400] : theme.accent[30]};
  }
`
export const ClientSwitcherWrapper = styled.div`
  margin-top: auto;
  padding-top: 12px;
  flex-shrink: 0;
`
export const ClientSwitcherName = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
`
export const ClientSwitcherLabel = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  color: ${({theme}) => theme.palette[600]};
  line-height: 14px;
`
export const ClientSwitcherValue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({theme}) => theme.palette[800]};
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ArrowCloseContainer = styled.div<ActiveProp>`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding:7px;
  width:30px;
  top:25px;
  z-index: 9;
  height:30px;
  border-radius: 100%;
  background-color: ${({theme}) => theme.isDark ? theme.palette[600] : theme.base.white};
  border:${({theme}) => `1px solid ${theme.grey[350]}`};
  position:absolute;
  left:${({active}) => active ? '55px' : '265px'};
  transition: 0.2s left ease-in-out;
  box-shadow: ${({theme}) => theme.isDark ? '0px 2px 2px rgba(0, 0, 0, 0.1)' : theme.shadows.control};
  &:hover{
    cursor:pointer;
    background-color:${({theme}) => theme.palette[100]}
  }

  @media screen and (max-width: 768px) {
    top: 20px;
    right: 12px;
    left: auto;
  }
`
